import React, { useEffect } from "react";
import WebFaqImg from "../Assets/img/w-faq-hero-img.svg";
import FaqData1 from "../Components/FaqData1";
import FaqData2 from "../Components/FaqData2";
const WebFaq = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Hero-Area --> */}
      <section className="a-isp-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-content">
                <h1>Frequently Asked</h1>
                <p>
                  Hendrerit porttitor ornare platea ante amet arcu at nunc.
                  Suscipit feugiat sagittis, id duis faucibus sit ultrices.
                  Netus sem diam turpis sollicitudin blandit massa ornare
                  facilisi.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-img">
                <img src={WebFaqImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End-Hero-Area -->	 */}

      <section className="faq-area web-faq-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Frequently Asked</h3>
                <p>
                  You can ask questions about our products and upcoming tools
                  and updates about our next move.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <FaqData1 />
            <FaqData2 />
          </div>
        </div>
      </section>
    </>
  );
};

export default WebFaq;
